import { createFileRoute } from '@tanstack/react-router';
import { MistakesPage } from '../features/parent/MistakesPage';
import { RequireAuth, STATS_ROLES } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent/mistakes')({
  component: () => <RequireAuth role={STATS_ROLES}>{(me) => <MistakesPage me={me} />}</RequireAuth>,
});
